import { getIVRInstance, deleteIVRInstance, updateIVRInstance, createIVRInstance, enableIVRInstance } from '@/services/xml-rpc/HotlineService';
export default {
    state: {
        groups: [],
        hotlines: {
            created: false,
            active: false
        }
    },

    getters: {
        isHotlineActive(state: any) {
            return state.hotlines.active;
        },
        isHotlineCreated(state: any) {
            return state.hotlines.created;
        }
    },

    actions: {
        changeHotlineActiveState(context: any, payload: boolean) {
            return enableIVRInstance(payload).then( response => {
                if (response.data.Success) {
                    context.commit('CHANGE_HOTLINE_ACTIVE_STATE', payload);
                    return true;
                } else {
                    context.commit('CHANGE_HOTLINE_ACTIVE_STATE', !payload);
                    return false;
                }
            });
        },
        changeHotlineCreatedState(context: any, payload: boolean) {
            context.commit('CHANGE_HOTLINE_CREATED_STATE', payload);
        },
        createHotlineIVR(context: any, payload: any) {
            return createIVRInstance(payload).then( response => {
                if (response.data.Success) {
                    context.commit('CHANGE_HOTLINE_ACTIVE_STATE', true);
                    context.commit('CHANGE_HOTLINE_CREATED_STATE', true);
                    return true;
                } else {
                    context.commit('CHANGE_HOTLINE_ACTIVE_STATE', false);
                    context.commit('CHANGE_HOTLINE_CREATED_STATE', false);
                    return false;
                }
            });
        },
        getHotlineIVR(context: any) {
            return getIVRInstance().then(response => {
                if (response.data.Success) {
                    context.commit('CHANGE_HOTLINE_CREATED_STATE', true);
                    return response.data.Params;
                } else {
                    if (response.data.Errormessage === 'HOTLINE_IVR_einstufig not found!') {
                        context.commit('CHANGE_HOTLINE_CREATED_STATE', false);
                    }
                    return response;
                }
            });
        },
        updateHotlineIVR(context: any, payload: any) {
            return updateIVRInstance(payload).then( response =>  {
                if (response.data.Success) {
                    return true;
                } else {
                    return false;
                }
            });
        },
        deleteHotlineIVR(context: any) {
            return deleteIVRInstance().then( response => {
                if (response.data.Success) {
                    context.commit('CHANGE_HOTLINE_ACTIVE_STATE', false);
                    context.commit('CHANGE_HOTLINE_CREATED_STATE', false);
                    return true;
                } else {
                    return false;
                }
            });
        }
    },

    mutations: {
        CHANGE_HOTLINE_ACTIVE_STATE(state: any, status: boolean) {
            state.hotlines.active = status;
        },
        CHANGE_HOTLINE_CREATED_STATE(state: any, status: boolean) {
            state.hotlines.created = status;
        }
    }

};
